const formatNumber = (amount: number | string | undefined): string => {
  if (amount) {
    let aux = Number(amount);
    return aux.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
  return '0';
};

const formatNumberDecimals = (amount: number | string | undefined, decimals: number = 5): string => {
  if (amount) {
    let aux = Number(amount);
    if (decimals) {
      return Number(aux.toFixed(decimals)).toString();
    } else {
      return (Math.floor(aux * 100000000)  / 100000000).toString();
    }
  }
  return '0';
};

const toInteger = (amount: number | string | undefined): number => {
  let aux = Number(amount);
  return Math.floor(aux);
};

const formatHexAddress = (address: string): string => {
  if (address) {
    const len = address.length;
    return address.slice(0, 5) + '...' + address.slice(len - 3, len);
  }
  return '';
}

const capitalizeFirstLetter = (text?: string): string => {
  return text?.replace(/^\w/, (c) => c.toUpperCase()) || '';
};

export {
  formatNumber,
  formatNumberDecimals,
  toInteger,
  capitalizeFirstLetter,
  formatHexAddress
}
